module.exports = __webpack_public_path__ + "img/award-zh.5c9a7b26.png";